
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9051"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9051"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $be8c8d5c828aaf1e$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["6oMUc","index.cf703ab7.js","K4bdh","nephcalc-high-resolution-logo-twitter.0636d1e8.png"]'));

class $193f87780df358da$var$NavView {
    _navBar = document.querySelector(".navbar");
    _sideIcon = document.querySelector(".side-icon");
    _body = document.querySelector("body");
    _answerContainer = document.querySelector(".answer-container");
    _interpretationContainer = document.querySelector(".interpretation-container");
    constructor(){
        this._handleSideMenu();
    }
    addHandlerRender(handler) {
        this._navBar.addEventListener("click", function(e) {
            e.preventDefault();
            const btn = e.target.closest(".eq-link");
            if (!btn) return;
            const equation = btn.dataset.eq;
            handler(equation);
        });
    }
    toggleSideMenu() {
        document.querySelector(".changeable-container").innerHTML = "";
        this._sideIcon.classList.toggle("hidden-icon");
        this._navBar.classList.toggle("hidden-mobile");
        this._body.classList.toggle("mobile-selected");
        this._answerContainer.innerHTML = "";
        this._interpretationContainer.innerHTML = "";
    }
    _handleSideMenu() {
        this._sideIcon.addEventListener("click", this.toggleSideMenu.bind(this));
    }
}
var $193f87780df358da$export$2e2bcd8739ae039 = new $193f87780df358da$var$NavView();


class $8406b9e4d568f4c5$var$InterpretationView {
    _interpretationContainer = document.querySelector(".interpretation-container");
    render(data) {
        this._interpretation = data.interpretation;
        const html = `<p class="interpretation-text">${this._interpretation}</p>`;
        this._clear();
        this._interpretationContainer.insertAdjacentHTML("afterbegin", html);
    }
    _clear() {
        this._interpretationContainer.innerHTML = "";
    }
}
var $8406b9e4d568f4c5$export$2e2bcd8739ae039 = new $8406b9e4d568f4c5$var$InterpretationView();


class $e4968b40bd2a919f$var$AnswerView {
    _container = document.querySelector(".answer-container");
    _answer;
    _calculation;
    _message = "All values must be entered and must be > 0 \uD83D\uDE22";
    render(data) {
        this._formattedAnswer = data.formattedAnswer;
        this._interpretation = data.interpretation;
        this._calculation = data.calculation;
        const html = this._generateHTML();
        this.clear();
        this._container.insertAdjacentHTML("afterbegin", html);
    }
    renderError(message = this._message) {
        const html = `<p class=answer>${message}</p>`;
        this.clear();
        this._container.insertAdjacentHTML("afterbegin", html);
    }
    clear() {
        this._container.innerHTML = "";
    }
    _generateHTML() {
        return `
    <p class="answer">${this._calculation}: ${this._formattedAnswer}<span class="tooltip"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="tooltip-icon">
    <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
  </svg>
  </span></p>`;
    }
    addHandlerRender(handler) {
        this._container.addEventListener("click", function(e) {
            if (!e.target.classList.contains("tooltip-icon")) return;
            handler();
        });
    }
}
var $e4968b40bd2a919f$export$2e2bcd8739ae039 = new $e4968b40bd2a919f$var$AnswerView();


class $5bb4ef6f100e1602$export$2e2bcd8739ae039 {
    _container = document.querySelector(".changeable-container");
    _clear() {
        this._container.innerHTML = "";
    }
    render() {
        const html = this.generateFullHTML();
        this._clear();
        this._container.insertAdjacentHTML("afterbegin", html);
    }
    generateFullHTML() {
        return `<div class="eq-title-container">
                    <h1 class="eq-title">${this._title}</h1>
            </div>
  <div class="eq-container grid-2-cols">
  ${this._backbone.map((obj, i, arr)=>{
            let label;
            const numOfItems = arr.length;
            if (obj.title.includes("serum-element")) label = `Serum ${this._element[0].toUpperCase() + this._element.slice(1)}`;
            if (obj.title.includes("urine-element")) label = `Urine ${this._element[0].toUpperCase() + this._element.slice(1)}`;
            return `<div class="eq-component ${i === numOfItems - 1 && numOfItems % 2 !== 0 && !this._additionalHTML ? "eq-component--center" : ""}">
                  <label for="${obj.title}" class="eq-label">${label ? label : obj.title.split("-").map((word)=>word[0].toUpperCase() + word.slice(1)).join(" ")}</label>
                      <div class="input-unit">
                          <input id="${obj.title}" class="eq-input eq-input--${obj.title}" type="number"/>
                          <select class="unit-selector unit-selector--${obj.title}">
                          ${obj.units.map((unit)=>{
                return `<option>${unit}</option>`;
            }).join("")}                         
                          </select>
                      </div>
                </div>`;
        }).join("")}
    ${this._additionalHTML ? this._additionalHTML : ""}
        <div class="btn-container">
            <button class="btn-calculate btn">submit</button>
        </div>
  </div>`;
    }
    addHandlerRender(handler) {
        const btn = this._container.querySelector(".btn-calculate");
        const that = this;
        btn.addEventListener("click", function(e) {
            e.preventDefault();
            try {
                const data = that._getData();
                handler(data);
            } catch (err) {
                console.log("error from addhandlerrender");
                handler(err);
            }
        });
    }
}


class $ee54bc9b51d4394a$export$9a5e662013b817d6 extends (0, $5bb4ef6f100e1602$export$2e2bcd8739ae039) {
    constructor(urineUnits, serumUnits){
        super();
        this._urineUnits = urineUnits;
        this._serumUnits = serumUnits;
        this._backbone = [
            {
                title: "urine-element",
                units: this._urineUnits
            },
            {
                title: "serum-element",
                units: this._serumUnits
            },
            {
                title: "serum-creatinine",
                units: [
                    "mg/dl",
                    "\xb5mol/L"
                ]
            },
            {
                title: "urine-creatinine",
                units: [
                    "mg/dl",
                    "mmol/L"
                ]
            }
        ];
    }
    _getData() {
        //return object of inputs
        const urineElementEl = this._container.querySelector(".eq-input--urine-element");
        const urineElementUnitEl = this._container.querySelector(".unit-selector--urine-element");
        const urineCreatinineEl = this._container.querySelector(".eq-input--urine-creatinine");
        const urineCreatinineUnitEl = this._container.querySelector(".unit-selector--urine-creatinine");
        const serumElementEl = this._container.querySelector(".eq-input--serum-element");
        const serumElementUnitEl = this._container.querySelector(".unit-selector--serum-element");
        const serumCreatinineEl = this._container.querySelector(".eq-input--serum-creatinine");
        const serumCreatinineUnitEl = this._container.querySelector(".unit-selector--serum-creatinine");
        const notRightValues = function(values) {
            return values.some((val)=>{
                if (!val || val < 0) return true;
            });
        };
        const arr = [
            urineElementEl?.value,
            urineCreatinineEl?.value,
            serumCreatinineEl?.value,
            serumElementEl?.value
        ];
        if (notRightValues(arr)) {
            console.log("error from _getData");
            console.log(arr);
            throw new Error("All values must be entered and must be > 0");
        }
        return {
            urineEl: {
                value: +urineElementEl.value,
                unit: urineElementUnitEl.value
            },
            urineCr: {
                value: +urineCreatinineEl.value,
                unit: urineCreatinineUnitEl.value
            },
            serumEl: {
                value: +serumElementEl.value,
                unit: serumElementUnitEl.value
            },
            serumCr: {
                value: +serumCreatinineEl.value,
                unit: serumCreatinineUnitEl.value
            }
        };
    }
}


class $f19bc41f73be26c6$var$FeMagView extends (0, $ee54bc9b51d4394a$export$9a5e662013b817d6) {
    _element = "magnesium";
    _title = "FeMg";
    constructor(){
        super([
            "mmol/L",
            "mg/g Cr"
        ], [
            "mg/dl"
        ]);
    }
}
var $f19bc41f73be26c6$export$2e2bcd8739ae039 = new $f19bc41f73be26c6$var$FeMagView();



class $e312b15f42b0bb41$var$FeNaView extends (0, $ee54bc9b51d4394a$export$9a5e662013b817d6) {
    _title = "FeNa";
    _element = "sodium";
    constructor(){
        super([
            "mEq/L"
        ], [
            "mEq/L"
        ]);
    }
}
var $e312b15f42b0bb41$export$2e2bcd8739ae039 = new $e312b15f42b0bb41$var$FeNaView();



class $1637ae1e99ea237d$var$FeUreaView extends (0, $ee54bc9b51d4394a$export$9a5e662013b817d6) {
    _title = "FeUrea";
    _element = "urea";
    constructor(){
        super([
            "mg/dl",
            "mEq/L"
        ], [
            "mg/dl",
            "mEq/L"
        ]);
    }
}
var $1637ae1e99ea237d$export$2e2bcd8739ae039 = new $1637ae1e99ea237d$var$FeUreaView();



class $25f9f349bdffe75f$var$FeCaView extends (0, $ee54bc9b51d4394a$export$9a5e662013b817d6) {
    _element = "calcium";
    _title = "FeCa";
    constructor(){
        super([
            "mg/dl"
        ], [
            "mg/dl"
        ]);
    }
}
var $25f9f349bdffe75f$export$2e2bcd8739ae039 = new $25f9f349bdffe75f$var$FeCaView();



class $ed970a09156565a5$var$FEPOView extends (0, $ee54bc9b51d4394a$export$9a5e662013b817d6) {
    _element = "phosphorous";
    _title = "FePO4";
    constructor(){
        super([
            "mg/dl"
        ], [
            "mg/dl"
        ]);
    }
}
var $ed970a09156565a5$export$2e2bcd8739ae039 = new $ed970a09156565a5$var$FEPOView();



class $5c396c13285f693e$export$a5a31a4872b41757 extends (0, $5bb4ef6f100e1602$export$2e2bcd8739ae039) {
    _title = "Osmolar Gap";
    _backbone = [
        {
            title: "serum-sodium",
            units: [
                "mmol/L"
            ]
        },
        {
            title: "serum-glucose",
            units: [
                "mg/dl"
            ]
        },
        {
            title: "serum-BUN",
            units: [
                "mg/dl"
            ]
        },
        {
            title: "measured-osmolality",
            units: [
                "mOsm/kg"
            ]
        },
        {
            title: "serum-etoh",
            units: [
                "mg/dl"
            ]
        }
    ];
    _getData() {
        //return object of inputs
        const serumSodiumEl = this._container.querySelector(".eq-input--serum-sodium");
        const serumSodiumUnitEl = this._container.querySelector(".unit-selector--serum-sodium");
        const serumGlucoseEl = this._container.querySelector(".eq-input--serum-glucose");
        const serumGlucoseUnitEl = this._container.querySelector(".unit-selector--serum-glucose");
        const serumBUNEl = this._container.querySelector(".eq-input--serum-BUN");
        const serumBUNUnitEl = this._container.querySelector(".unit-selector--serum-BUN");
        const measuredOsmolalityEl = this._container.querySelector(".eq-input--measured-osmolality");
        const measuredOsmolalityUnitEl = this._container.querySelector(".unit-selector--measured-osmolality");
        const serumETOHEl = this._container.querySelector(".eq-input--serum-etoh");
        const serumETOHUnitEl = this._container.querySelector(".unit-selector--serum-etoh");
        const notRightValues = function(values) {
            return values.some((val)=>{
                if (!val || val < 0) return true;
            });
        };
        const arr = [
            serumSodiumEl?.value,
            serumGlucoseEl?.value,
            serumBUNEl?.value,
            measuredOsmolalityEl?.value
        ];
        if (notRightValues(arr)) {
            console.log("error from _getData");
            console.log(arr);
            throw new Error("All values must be entered and must be > 0");
        }
        return {
            serumSodium: {
                value: +serumSodiumEl.value,
                unit: serumSodiumUnitEl.value
            },
            serumGlucose: {
                value: +serumGlucoseEl.value,
                unit: serumGlucoseUnitEl.value
            },
            serumBUN: {
                value: +serumBUNEl.value,
                unit: serumBUNUnitEl.value
            },
            measuredOsmolality: {
                value: +measuredOsmolalityEl.value,
                unit: measuredOsmolalityUnitEl.value
            },
            serumETOH: {
                value: +serumETOHEl.value,
                unit: serumETOHUnitEl.value
            }
        };
    }
}
var $5c396c13285f693e$export$2e2bcd8739ae039 = new $5c396c13285f693e$export$a5a31a4872b41757();



class $a312787cc7bfac19$export$58d484853a5a684c extends (0, $5bb4ef6f100e1602$export$2e2bcd8739ae039) {
    _title = "Electrolyte Free Water";
    _backbone = [
        {
            title: "urine-sodium",
            units: [
                "mEq/L"
            ]
        },
        {
            title: "urine-potassium",
            units: [
                "mEq/L"
            ]
        },
        {
            title: "serum-sodium",
            units: [
                "mmol/L"
            ]
        },
        {
            title: "urine-volume",
            units: [
                "ml/hour"
            ]
        }
    ];
    //  // eFWC = V(1 - (Una + Uk / Pna))
    // generateHTML() {
    //   return `   <div class="eq-title-container">
    //   <h1 class="eq-title">${this._title}</h1>
    // </div>
    // <div class="eq-container grid-2-cols">
    //   <div class="eq-component">
    //     <label for="urine-sodium," class="eq-label">Urine Sodium</label>
    //     <div class="input-unit">
    //       <input id="urine-sodium" class="eq-input eq-input--urine-sodium" type="number"/>
    //       <select class="unit-selector unit-selector--urine-sodium">
    //       <option>mEq/L</option>
    //       </select>
    //     </div>
    //   </div>
    //   <div class="eq-component eq-component-right">
    //     <label for="urine-potassium" class="eq-label">Urine Potassium</label>
    //     <div class="input-unit">
    //       <input id="urine-potassium" class="eq-input eq-input--urine-potassium" type="number"/>
    //       <select class="unit-selector unit-selector--urine-potassium">
    //         <option>mEq/L</option>
    //       </select>
    //     </div>
    //   </div>
    //   <div class="eq-component">
    //     <label for="serum-sodium" class="eq-label">Serum Sodium</label>
    //     <div class="input-unit">
    //       <input id="serum-sodium" class="eq-input eq-input--serum-sodium" type="number"/>
    //       <select class="unit-selector unit-selector--serum-sodium">
    //       <option>mmol/L</option>
    //       </select>
    //     </div>
    //   </div>
    //   <div class="eq-component eq-component-right">
    //     <label for="urine-volume" class="eq-label">Urine Volume</label>
    //     <div class="input-unit">
    //       <input id="urine-volume" class="eq-input eq-input--urine-volume" type="number"/>
    //       <select class="unit-selector unit-selector--urine-volume">
    //         <option>ml/hour</option>
    //       </select>
    //     </div>
    //   </div>
    //   <div class="btn-container">
    //   <button class="btn-calculate btn">submit</button>
    // </div>
    // </div>
    // </div>`;
    // }
    _getData() {
        //return object of inputs
        const serumSodiumEl = this._container.querySelector(".eq-input--serum-sodium");
        const serumSodiumUnitEl = this._container.querySelector(".unit-selector--serum-sodium");
        const urinePotassiumEl = this._container.querySelector(".eq-input--urine-potassium");
        const urinePotassiumUnitEl = this._container.querySelector(".unit-selector--urine-potassium");
        const urineSodiumEl = this._container.querySelector(".eq-input--urine-sodium");
        const urineSodiumUnitEl = this._container.querySelector(".unit-selector--urine-sodium");
        const urineVolumeEl = this._container.querySelector(".eq-input--urine-volume");
        const urineVolumeUnitEl = this._container.querySelector(".unit-selector--urine-volume");
        const notRightValues = function(values) {
            return values.some((val)=>{
                if (!val || val < 0) return true;
            });
        };
        const arr = [
            serumSodiumEl?.value,
            urinePotassiumEl?.value,
            urineSodiumEl?.value,
            urineVolumeEl?.value
        ];
        if (notRightValues(arr)) {
            console.log("error from _getData");
            console.log(arr);
            throw new Error("All values must be entered and must be > 0");
        }
        return {
            serumSodium: {
                value: +serumSodiumEl.value,
                unit: serumSodiumUnitEl.value
            },
            urinePotassium: {
                value: +urinePotassiumEl.value,
                unit: urinePotassiumUnitEl.value
            },
            urineSodium: {
                value: +urineSodiumEl.value,
                unit: urineSodiumUnitEl.value
            },
            urineVolume: {
                value: +urineVolumeEl.value,
                unit: urineVolumeUnitEl.value
            }
        };
    }
}
var $a312787cc7bfac19$export$2e2bcd8739ae039 = new $a312787cc7bfac19$export$58d484853a5a684c();



class $6131b0ab11ac723f$export$e1336a8562f72ebf extends (0, $5bb4ef6f100e1602$export$2e2bcd8739ae039) {
    _male = true;
    _title = "Free Water Deficit";
    _additionalHTML = `<div class="eq-component">

    <label class="eq-label label--gender">Gender</label>
    <div class="gender-container">
      <button class="btn btn--gender btn--male">Male</button>
      <button class="btn btn--gender btn--female">Female</button>
    </div>
  </div>`;
    _backbone = [
        {
            title: "serum-sodium",
            units: [
                "mmol/L"
            ]
        },
        {
            title: "goal-sodium",
            units: [
                "mEq/L"
            ]
        },
        {
            title: "patient-weight",
            units: [
                "kg"
            ]
        }
    ];
    _changeGender(e) {
        const genderBtn = e.target.closest(".btn--gender");
        if (!genderBtn) return;
        const genderBtns = document.querySelectorAll(".btn--gender");
        genderBtns.forEach((btn)=>{
            btn.classList.remove("gender-clicked");
        });
        genderBtn.classList.add("gender-clicked");
        if (genderBtn.classList.contains("btn--female")) this._male = false;
        else this._male = true;
    }
    addHandlerGender() {
        const container = document.querySelector(".gender-container");
        container.addEventListener("click", this._changeGender.bind(this));
    }
    _getData() {
        //return object of inputs
        const serumSodiumEl = this._container.querySelector(".eq-input--serum-sodium");
        const serumSodiumUnitEl = this._container.querySelector(".unit-selector--serum-sodium");
        const goalSodiumEl = this._container.querySelector(".eq-input--goal-sodium");
        const goalSodiumUnitEl = this._container.querySelector(".unit-selector--goal-sodium");
        const weightEl = this._container.querySelector(".eq-input--patient-weight");
        const weightUnitEl = this._container.querySelector(".unit-selector--patient-weight");
        const notRightValues = function(values) {
            return values.some((val)=>{
                if (!val || val < 0) return true;
            });
        };
        console.log(serumSodiumEl?.value, goalSodiumEl?.value, weightEl?.value);
        const valuesArr = [
            serumSodiumEl?.value,
            goalSodiumEl?.value,
            weightEl?.value
        ];
        if (notRightValues(valuesArr)) {
            console.log("error from _getData");
            throw new Error("All values must be entered and must be > 0");
        }
        return {
            serumSodium: {
                value: +serumSodiumEl.value,
                unit: serumSodiumUnitEl.value
            },
            goalSodium: {
                value: +goalSodiumEl.value,
                unit: goalSodiumUnitEl.value
            },
            weight: {
                value: +weightEl.value,
                unit: weightUnitEl.value
            },
            maleGender: {
                value: this._male
            }
        };
    }
}
var $6131b0ab11ac723f$export$2e2bcd8739ae039 = new $6131b0ab11ac723f$export$e1336a8562f72ebf();



class $a13a4baa8410dcf8$export$7c27eb79885c8dfe extends (0, $5bb4ef6f100e1602$export$2e2bcd8739ae039) {
    _title = "Urine Anion Gap";
    _backbone = [
        {
            title: "urine-sodium",
            units: [
                "mmol/L"
            ]
        },
        {
            title: "urine-potassium",
            units: [
                "mEq/L",
                "mmol/L"
            ]
        },
        {
            title: "urine-chloride",
            units: [
                "mEq/L",
                "mmol/L"
            ]
        }
    ];
    _getData() {
        //return object of inputs
        const urineSodiumEl = this._container.querySelector(".eq-input--urine-sodium");
        const urineSodiumUnitEl = this._container.querySelector(".unit-selector--urine-sodium");
        const urinePotassiumEl = this._container.querySelector(".eq-input--urine-potassium");
        const urinePotassiumUnitEl = this._container.querySelector(".unit-selector--urine-potassium");
        const urineChlorideEl = this._container.querySelector(".eq-input--urine-chloride");
        const urineChlorideUnitEl = this._container.querySelector(".unit-selector--urine-chloride");
        const notRightValues = function(values) {
            return values.some((val)=>{
                if (!val || val < 0) return true;
            });
        };
        const arr = [
            urineSodiumEl?.value,
            urinePotassiumEl?.value,
            urineChlorideEl?.value
        ];
        if (notRightValues(arr)) {
            console.log("error from _getData");
            console.log(arr);
            throw new Error("All values must be entered and must be > 0");
        }
        return {
            urineSodium: {
                value: +urineSodiumEl.value,
                unit: urineSodiumUnitEl.value
            },
            urinePotassium: {
                value: +urinePotassiumEl.value,
                unit: urinePotassiumUnitEl.value
            },
            urineChloride: {
                value: +urineChlorideEl.value,
                unit: urineChlorideUnitEl.value
            }
        };
    }
}
var $a13a4baa8410dcf8$export$2e2bcd8739ae039 = new $a13a4baa8410dcf8$export$7c27eb79885c8dfe();



class $05d89272644e736c$export$4a1312c30d405411 extends (0, $5bb4ef6f100e1602$export$2e2bcd8739ae039) {
    _title = "24h CrCl";
    _backbone = [
        {
            title: "urine-creatinine",
            units: [
                "mg/dl"
            ]
        },
        {
            title: "serum-creatinine",
            units: [
                "mg/dl"
            ]
        },
        {
            title: "urine-volume",
            units: [
                "ml/24h"
            ]
        }
    ];
    _getData() {
        //return object of inputs
        const urineCreatinineEl = this._container.querySelector(".eq-input--urine-creatinine");
        const urineCreatinineUnitEl = this._container.querySelector(".unit-selector--urine-creatinine");
        const serumCreatinineEl = this._container.querySelector(".eq-input--serum-creatinine");
        const serumCreatinineUnitEl = this._container.querySelector(".unit-selector--serum-creatinine");
        const urineVolumeEl = this._container.querySelector(".eq-input--urine-volume");
        const urineVolumeUnitEl = this._container.querySelector(".unit-selector--urine-volume");
        const notRightValues = function(values) {
            return values.some((val)=>{
                if (!val || val < 0) return true;
            });
        };
        const arr = [
            urineCreatinineEl?.value,
            serumCreatinineEl?.value,
            urineVolumeEl?.value
        ];
        if (notRightValues(arr)) {
            console.log("error from _getData");
            console.log(arr);
            throw new Error("All values must be entered and must be > 0");
        }
        return {
            urineCreatinine: {
                value: +urineCreatinineEl.value,
                unit: urineCreatinineUnitEl.value
            },
            serumCreatinine: {
                value: +serumCreatinineEl.value,
                unit: serumCreatinineUnitEl.value
            },
            urineVolume: {
                value: +urineVolumeEl.value,
                unit: urineVolumeUnitEl.value
            }
        };
    }
}
var $05d89272644e736c$export$2e2bcd8739ae039 = new $05d89272644e736c$export$4a1312c30d405411();



class $920d0e85dce62342$export$9b98652162adde79 extends (0, $5bb4ef6f100e1602$export$2e2bcd8739ae039) {
    _title = "TTKG";
    _backbone = [
        {
            title: "urine-potassium",
            units: [
                "mmol/L"
            ]
        },
        {
            title: "serum-osmolality",
            units: [
                "mOsm/kg"
            ]
        },
        {
            title: "serum-potassium",
            units: [
                "mmol/L"
            ]
        },
        {
            title: "urine-osmolality",
            units: [
                "mOsm/kg"
            ]
        }
    ];
    //ttkg = urine K(mmol/L) x serumOsm(mOsm/kg) / serumK(mmol/L) X UOsm(mOsm/kg)
    //high ttkg in setting of high K means not properly excreting
    //low ttkg in setting of hypokalemia suggests potassium wasting.
    _getData() {
        //return object of inputs
        const urinePotassiumEl = this._container.querySelector(".eq-input--urine-potassium");
        const urinePotassiumUnitEl = this._container.querySelector(".unit-selector--urine-potassium");
        const serumPotassiumEl = this._container.querySelector(".eq-input--serum-potassium");
        const serumPotassiumUnitEl = this._container.querySelector(".unit-selector--serum-potassium");
        const serumOsmEl = this._container.querySelector(".eq-input--serum-osmolality");
        const serumOsmUnitEl = this._container.querySelector(".unit-selector--serum-osmolality");
        const urineOsmEl = this._container.querySelector(".eq-input--urine-osmolality");
        const urineOsmUnitEl = this._container.querySelector(".unit-selector--urine-osmolality");
        const notRightValues = function(values) {
            return values.some((val)=>{
                if (!val || val < 0) return true;
            });
        };
        const arr = [
            urinePotassiumEl?.value,
            serumPotassiumEl?.value,
            serumOsmEl?.value,
            urineOsmEl?.value
        ];
        if (notRightValues(arr)) {
            console.log("error from _getData");
            console.log(arr);
            throw new Error("All values must be entered and must be > 0");
        }
        return {
            urinePotassium: {
                value: +urinePotassiumEl.value,
                unit: urinePotassiumUnitEl.value
            },
            serumPotassium: {
                value: +serumPotassiumEl.value,
                unit: serumPotassiumUnitEl.value
            },
            serumOsm: {
                value: +serumOsmEl.value,
                unit: serumOsmUnitEl.value
            },
            urineOsm: {
                value: +urineOsmEl.value,
                unit: urineOsmUnitEl.value
            }
        };
    }
}
var $920d0e85dce62342$export$2e2bcd8739ae039 = new $920d0e85dce62342$export$9b98652162adde79();



class $e216584d03032389$export$c152f674dafb3ba7 extends (0, $5bb4ef6f100e1602$export$2e2bcd8739ae039) {
    _title = "Winter's formula";
    _backbone = [
        {
            title: "serum-bicarb",
            units: [
                "mEq/L"
            ]
        }
    ];
    _getData() {
        //return object of inputs
        const serumBicarbEl = this._container.querySelector(".eq-input--serum-bicarb");
        const serumBicarbUnitEl = this._container.querySelector(".unit-selector--serum-bicarb");
        const notRightValues = function(values) {
            return values.some((val)=>{
                if (!val || val < 0) return true;
            });
        };
        const arr = [
            serumBicarbEl?.value
        ];
        if (notRightValues(arr)) {
            console.log("error from _getData");
            console.log(arr);
            throw new Error("All values must be entered and must be > 0");
        }
        return {
            serumBicarb: {
                value: +serumBicarbEl.value,
                unit: serumBicarbUnitEl.value
            }
        };
    }
}
var $e216584d03032389$export$2e2bcd8739ae039 = new $e216584d03032389$export$c152f674dafb3ba7();



class $b0a39dd7e68324c8$export$d163b3718c6b57a0 extends (0, $5bb4ef6f100e1602$export$2e2bcd8739ae039) {
    _title = "Serum Anion Gap";
    _backbone = [
        {
            title: "serum-sodium",
            units: [
                "mEq/L"
            ]
        },
        {
            title: "serum-chloride",
            units: [
                "mEq/L"
            ]
        },
        {
            title: "serum-bicarb",
            units: [
                "mEq/L"
            ]
        },
        {
            title: "serum-albumin",
            units: [
                "g/dl"
            ]
        }
    ];
    _getData() {
        //return object of inputs
        const serumSodiumEl = this._container.querySelector(".eq-input--serum-sodium");
        const serumSodiumUnitEl = this._container.querySelector(".unit-selector--serum-sodium");
        const serumChlorideEl = this._container.querySelector(".eq-input--serum-chloride");
        const serumChlorideUnitEl = this._container.querySelector(".unit-selector--serum-chloride");
        const serumBicarbEl = this._container.querySelector(".eq-input--serum-bicarb");
        const serumBicarbUnitEl = this._container.querySelector(".unit-selector--serum-bicarb");
        const serumAlbuminEl = this._container.querySelector(".eq-input--serum-albumin");
        const serumAlbuminUnitEl = this._container.querySelector(".unit-selector--serum-albumin");
        const notRightValues = function(values) {
            return values.some((val)=>{
                if (!val || val < 0) return true;
            });
        };
        const arr = [
            serumSodiumEl?.value,
            serumChlorideEl?.value,
            serumBicarbEl?.value,
            serumAlbuminEl?.value
        ];
        if (notRightValues(arr)) {
            console.log("error from _getData");
            console.log(arr);
            throw new Error("All values must be entered and must be > 0");
        }
        return {
            serumSodium: {
                value: +serumSodiumEl.value,
                unit: serumSodiumUnitEl.value
            },
            serumChloride: {
                value: +serumChlorideEl.value,
                unit: serumChlorideUnitEl.value
            },
            serumBicarb: {
                value: +serumBicarbEl.value,
                unit: serumBicarbUnitEl.value
            },
            serumAlbumin: {
                value: +serumAlbuminEl.value,
                unit: serumAlbuminUnitEl.value
            }
        };
    }
}
var $b0a39dd7e68324c8$export$2e2bcd8739ae039 = new $b0a39dd7e68324c8$export$d163b3718c6b57a0();



class $18793a966bd38522$export$9db2db6eaca1c8bb extends (0, $5bb4ef6f100e1602$export$2e2bcd8739ae039) {
    _title = "Corrected Sodium";
    _backbone = [
        {
            title: "serum-glucose",
            units: [
                "mg/dl"
            ]
        },
        {
            title: "serum-sodium",
            units: [
                "mEq/L"
            ]
        }
    ];
    _getData() {
        const serumGlucoseEl = this._container.querySelector(".eq-input--serum-glucose");
        const serumGlucoseUnitEl = this._container.querySelector(".unit-selector--serum-glucose");
        const serumSodiumEl = this._container.querySelector(".eq-input--serum-sodium");
        const serumSodiumUnitEl = this._container.querySelector(".unit-selector--serum-sodium");
        const notRightValues = function(values) {
            return values.some((val)=>{
                if (!val || val < 0) return true;
            });
        };
        const arr = [
            serumGlucoseEl?.value,
            serumSodiumEl?.value
        ];
        if (notRightValues(arr)) {
            console.log("error from _getData");
            console.log(arr);
            throw new Error("All values must be entered and must be > 0");
        }
        return {
            serumGlucose: {
                value: +serumGlucoseEl.value,
                unit: serumGlucoseUnitEl.value
            },
            serumSodium: {
                value: +serumSodiumEl.value,
                unit: serumSodiumUnitEl.value
            }
        };
    }
}
var $18793a966bd38522$export$2e2bcd8739ae039 = new $18793a966bd38522$export$9db2db6eaca1c8bb();



class $0f4dc5caad29475f$export$77bb4c128e56003d extends (0, $5bb4ef6f100e1602$export$2e2bcd8739ae039) {
    _title = "Urine Osmolar Gap";
    _backbone = [
        {
            title: "urine-sodium",
            units: [
                "mEq/L"
            ]
        },
        {
            title: "urine-potassium",
            units: [
                "mEq/L"
            ]
        },
        {
            title: "urine-glucose",
            units: [
                "mg/dl"
            ]
        },
        {
            title: "urine-urea",
            units: [
                "mg/dl"
            ]
        },
        {
            title: "measured-osmolality",
            units: [
                "mOsm/kg"
            ]
        }
    ];
    _getData() {
        //return object of inputs
        const urineSodiumEl = this._container.querySelector(".eq-input--urine-sodium");
        const urineSodiumUnitEl = this._container.querySelector(".unit-selector--urine-sodium");
        const urinePotassiumEl = this._container.querySelector(".eq-input--urine-potassium");
        const urinePotassiumUnitEl = this._container.querySelector(".unit-selector--urine-potassium");
        const urineGlucoseEl = this._container.querySelector(".eq-input--urine-glucose");
        const urineGlucoseUnitEl = this._container.querySelector(".unit-selector--urine-glucose");
        const urineUreaEl = this._container.querySelector(".eq-input--urine-urea");
        const urineUreaUnitEl = this._container.querySelector(".unit-selector--urine-urea");
        const measuredOsmolalityEl = this._container.querySelector(".eq-input--measured-osmolality");
        const measuredOsmolalityUnitEl = this._container.querySelector(".unit-selector--measured-osmolality");
        const notRightValues = function(values) {
            return values.some((val)=>{
                if (!val || val < 0) return true;
            });
        };
        const arr = [
            urineSodiumEl?.value,
            urinePotassiumEl?.value,
            urineGlucoseEl?.value,
            urineUreaEl?.value,
            measuredOsmolalityEl?.value
        ];
        if (notRightValues(arr)) {
            console.log("error from _getData");
            console.log(arr);
            throw new Error("All values must be entered and must be > 0");
        }
        return {
            urineSodium: {
                value: +urineSodiumEl.value,
                unit: urineSodiumUnitEl.value
            },
            urinePotassium: {
                value: +urinePotassiumEl.value,
                unit: urinePotassiumUnitEl.value
            },
            urineGlucose: {
                value: +urineGlucoseEl.value,
                unit: urineGlucoseUnitEl.value
            },
            urineUrea: {
                value: +urineUreaEl.value,
                unit: urineUreaUnitEl.value
            },
            measuredOsmolality: {
                value: +measuredOsmolalityEl.value,
                unit: measuredOsmolalityUnitEl.value
            }
        };
    }
}
var $0f4dc5caad29475f$export$2e2bcd8739ae039 = new $0f4dc5caad29475f$export$77bb4c128e56003d();



class $f0c02b030a95713d$export$1ac74e3a519eda68 extends (0, $5bb4ef6f100e1602$export$2e2bcd8739ae039) {
    _title = "Corrected Calcium";
    _backbone = [
        {
            title: "serum-calcium",
            units: [
                "mg/dl"
            ]
        },
        {
            title: "serum-albumin",
            units: [
                "g/dl"
            ]
        }
    ];
    _getData() {
        const serumCalciumEl = this._container.querySelector(".eq-input--serum-calcium");
        const serumCalciumUnitEl = this._container.querySelector(".unit-selector--serum-calcium");
        const serumAlbuminEl = this._container.querySelector(".eq-input--serum-albumin");
        const serumAlbuminUnitEl = this._container.querySelector(".unit-selector--serum-albumin");
        const notRightValues = function(values) {
            return values.some((val)=>{
                if (!val || val < 0) return true;
            });
        };
        const arr = [
            serumCalciumEl?.value,
            serumAlbuminEl?.value
        ];
        if (notRightValues(arr)) {
            console.log("error from _getData");
            console.log(arr);
            throw new Error("All values must be entered and must be > 0");
        }
        return {
            serumCalcium: {
                value: +serumCalciumEl.value,
                unit: serumCalciumUnitEl.value
            },
            serumAlbumin: {
                value: +serumAlbuminEl.value,
                unit: serumAlbuminUnitEl.value
            }
        };
    }
}
var $f0c02b030a95713d$export$2e2bcd8739ae039 = new $f0c02b030a95713d$export$1ac74e3a519eda68();



class $f073d25bf91445dd$export$3c57abdaa65e8cba extends (0, $5bb4ef6f100e1602$export$2e2bcd8739ae039) {
    _title = "Total Plasma volume";
    _backbone = [
        {
            title: "patient-weight",
            units: [
                "kg"
            ]
        },
        {
            title: "patient-hematocrit",
            units: [
                "%"
            ]
        }
    ];
    _getData() {
        const patientWeightEl = this._container.querySelector(".eq-input--patient-weight");
        const patientWeightUnitEl = this._container.querySelector(".unit-selector--patient-weight");
        const patientHematocritEl = this._container.querySelector(".eq-input--patient-hematocrit");
        const patientHematocritUnitEl = this._container.querySelector(".unit-selector--patient-hematocrit");
        const notRightValues = function(values) {
            return values.some((val)=>{
                if (!val || val < 0) return true;
            });
        };
        const arr = [
            patientWeightEl?.value,
            patientHematocritEl?.value
        ];
        if (notRightValues(arr)) {
            console.log("error from _getData");
            console.log(arr);
            throw new Error("All values must be entered and must be > 0");
        }
        return {
            patientWeight: {
                value: +patientWeightEl.value,
                unit: patientWeightUnitEl.value
            },
            patientHematocrit: {
                value: +patientHematocritEl.value,
                unit: patientHematocritUnitEl.value
            }
        };
    }
}
var $f073d25bf91445dd$export$2e2bcd8739ae039 = new $f073d25bf91445dd$export$3c57abdaa65e8cba();


const $5a8135927f4d8c1a$export$ca000e230c0caa3e = {
    answer: "",
    formattedAnswer: "",
    calculation: "",
    interpretation: ""
};
const $5a8135927f4d8c1a$export$5e42ddf837e2ac74 = function(calctype) {
    $5a8135927f4d8c1a$export$ca000e230c0caa3e.calculation = calctype;
};
const $5a8135927f4d8c1a$export$507d97aea0e924af = function(values) {
    const sodium = 2 * values.serumSodium.value;
    const glucose = values.serumGlucose.value / 18;
    const BUN = values.serumBUN.value / 2.8;
    const ETOH = values.serumETOH.value / 4.6;
    $5a8135927f4d8c1a$export$ca000e230c0caa3e.answer = (values.measuredOsmolality.value - (sodium + glucose + BUN + ETOH)).toFixed(1);
    $5a8135927f4d8c1a$export$ca000e230c0caa3e.formattedAnswer = (values.measuredOsmolality.value - (sodium + glucose + BUN + ETOH)).toFixed(1);
};
const $5a8135927f4d8c1a$export$2b4553184b655286 = function(values) {
    // eFWC = V(1 - (Una + Uk / Pna))
    //V is in ml/hour and answer is ml/hr
    $5a8135927f4d8c1a$export$ca000e230c0caa3e.answer = values.urineVolume.value * (1 - (values.urineSodium.value + values.urinePotassium.value) / values.serumSodium.value).toFixed(1);
    $5a8135927f4d8c1a$export$ca000e230c0caa3e.formattedAnswer = `${(values.urineVolume.value * (1 - (values.urineSodium.value + values.urinePotassium.value) / values.serumSodium.value)).toFixed(1)} ml/hour`;
};
const $5a8135927f4d8c1a$export$ad8ef1ae2dfea01a = function(values) {
    let percentageTBW = 0.6;
    if (values.maleGender.value === false) percentageTBW = 0.5;
    $5a8135927f4d8c1a$export$ca000e230c0caa3e.answer = values.weight.value * percentageTBW * (values.serumSodium.value / values.goalSodium.value - 1).toFixed(1);
    $5a8135927f4d8c1a$export$ca000e230c0caa3e.formattedAnswer = `${(values.weight.value * percentageTBW * (values.serumSodium.value / values.goalSodium.value - 1)).toFixed(1)} L`;
//Free water deficit: = TBW(kg) x (Measured Na / Ideal Na – 1)
//male is 60% water and female is 50% water.
};
const $5a8135927f4d8c1a$export$e21e2518db2872d2 = function(values) {
    //na + k - cl
    const result = values.urineSodium.value + values.urinePotassium.value - values.urineChloride.value;
    $5a8135927f4d8c1a$export$ca000e230c0caa3e.answer = result;
    $5a8135927f4d8c1a$export$ca000e230c0caa3e.formattedAnswer = `${result > 0 ? "+" : ""}${result}`;
};
const $5a8135927f4d8c1a$export$a5c322cbbfb546bb = function(values) {
    //CrCl (ml/min) = UCr x UVol(ml) / SCr x 1440
    const result = (values.urineCreatinine.value * values.urineVolume.value / (values.serumCreatinine.value * 1440)).toFixed(2);
    $5a8135927f4d8c1a$export$ca000e230c0caa3e.answer = result;
    $5a8135927f4d8c1a$export$ca000e230c0caa3e.formattedAnswer = `${result} ml/min`;
};
const $5a8135927f4d8c1a$export$63ddbb1edc5cb637 = function(values) {
    //ttkg = urine K(mmol/L) x serumOsm(mOsm/kg) / serumK(mmol/L) X UOsm(mOsm/kg)
    //high ttkg in setting of high K means not properly excreting
    //low ttkg in setting of hypokalemia suggests potassium wasting.
    const result = (values.urinePotassium.value * values.serumOsm.value / (values.serumPotassium.value * values.urineOsm.value)).toFixed(2);
    $5a8135927f4d8c1a$export$ca000e230c0caa3e.answer = result;
    $5a8135927f4d8c1a$export$ca000e230c0caa3e.formattedAnswer = result;
};
const $5a8135927f4d8c1a$export$c13515ff9746e41 = function(values) {
    //expected PCO2mmHg = (1.5 x HCO3mEq/L) + 8 +/- 2
    const result = (1.5 * values.serumBicarb.value + 8).toFixed(1);
    $5a8135927f4d8c1a$export$ca000e230c0caa3e.answer = result;
    $5a8135927f4d8c1a$export$ca000e230c0caa3e.formattedAnswer = `${result} +/- 2 mmHg`;
};
const $5a8135927f4d8c1a$export$c45ea910e5730521 = function(values) {
    const result = values.serumSodium.value - (values.serumChloride.value + values.serumBicarb.value) + 2.5 * (4 - values.serumAlbumin.value);
    $5a8135927f4d8c1a$export$ca000e230c0caa3e.answer = result;
    $5a8135927f4d8c1a$export$ca000e230c0caa3e.formattedAnswer = result;
};
const $5a8135927f4d8c1a$export$2d0d9ab62031713e = function(values) {
    const firstResult = 0.016 * (values.serumGlucose.value - 100);
    const result = values.serumSodium.value + firstResult;
    $5a8135927f4d8c1a$export$ca000e230c0caa3e.answer = result;
    $5a8135927f4d8c1a$export$ca000e230c0caa3e.formattedAnswer = `${result} mEq/L`;
};
const $5a8135927f4d8c1a$export$4d6102d72c76245f = function(values) {
    //uag = measured u/osm - calc u/osm
    //calc = 2 X (Na + K) + urea mg/dl / 2.8 + glucose mg/dl / 2.8
    const sodiumPotassium = 2 * (values.urineSodium.value + values.urinePotassium.value);
    const ureaNitrogen = values.urineUrea.value / 2.8;
    const glucose = values.urineGlucose.value / 18;
    const result = (values.measuredOsmolality.value - (sodiumPotassium + ureaNitrogen + glucose)).toFixed(2);
    $5a8135927f4d8c1a$export$ca000e230c0caa3e.answer = result;
    $5a8135927f4d8c1a$export$ca000e230c0caa3e.formattedAnswer = result;
};
const $5a8135927f4d8c1a$export$ea6ee1d9a056bd7a = function(values) {
    let result;
    if (values.serumAlbumin.value >= 4) {
        result = values.serumCalcium.value.toFixed(1);
        return $5a8135927f4d8c1a$export$ca000e230c0caa3e.formattedAnswer = `${result} mg/dl`;
    }
    result = ((4 - values.serumAlbumin.value) * 0.8 + values.serumCalcium.value).toFixed(1);
    $5a8135927f4d8c1a$export$ca000e230c0caa3e.answer = result;
    $5a8135927f4d8c1a$export$ca000e230c0caa3e.formattedAnswer = `${result} mg/dl`;
};
const $5a8135927f4d8c1a$export$f5d3318ee5a4f48a = function(values) {
    const TBV = 70 * values.patientWeight.value; //in kg and gives ml
    const result = (TBV * (1 - values.patientHematocrit.value / 100) / 1000).toFixed(1);
    $5a8135927f4d8c1a$export$ca000e230c0caa3e.answer = result;
    $5a8135927f4d8c1a$export$ca000e230c0caa3e.formattedAnswer = `${result} L`;
};


const $9697ec0469b41fd7$var$convertSerumCreatinine = function(creatinine) {
    return creatinine * 0.113;
};
const $9697ec0469b41fd7$var$convertUrineCreatinine = function(creatinine) {
    return creatinine * 11.31;
};
const $9697ec0469b41fd7$var$convertSerumMagnesium = function(mag) {
    return mag * 2.4305;
};
const $9697ec0469b41fd7$var$convertUrineMagPerCreatinine = function(mag, cr) {
    return mag * (cr / 1000);
};
const $9697ec0469b41fd7$var$determineMagnesium = function(values) {
    if (values.serumEl.unit === "mmol/L") values.serumEl.value = $9697ec0469b41fd7$var$convertSerumMagnesium(values.serumEl.value);
    if (values.urineEl.unit === "mmol/L") values.urineEl.value = $9697ec0469b41fd7$var$convertSerumMagnesium(values.serumEl.value);
    if (values.urineEl.unit === "mg/g Cr") values.urineEl.value = $9697ec0469b41fd7$var$convertUrineMagPerCreatinine(values.urineEl.value, values.urineCr.value);
};
const $9697ec0469b41fd7$var$determineCreatinine = function(values) {
    if (values.serumCr.unit === "\xb5mol/L") values.serumCr.value = $9697ec0469b41fd7$var$convertSerumCreatinine(values.serumCr.value);
    if (values.urineCr.unit === "mmol/L") values.urineCr.value = $9697ec0469b41fd7$var$convertUrineCreatinine(values.urineCr.value);
};
const $9697ec0469b41fd7$var$calculateFe = function(values, magFactor = 1) {
    (0, $5a8135927f4d8c1a$export$ca000e230c0caa3e).answer = (values.urineEl.value * values.serumCr.value / (values.urineCr.value * values.serumEl.value * magFactor) * 100).toFixed(2);
    (0, $5a8135927f4d8c1a$export$ca000e230c0caa3e).formattedAnswer = `
  ${(values.urineEl.value * values.serumCr.value / (values.urineCr.value * values.serumEl.value * magFactor) * 100).toFixed(2)}%`;
};
const $9697ec0469b41fd7$export$5b84e5bc38d35d49 = function(values) {
    $9697ec0469b41fd7$var$determineCreatinine(values);
    $9697ec0469b41fd7$var$calculateFe(values);
    if ((0, $5a8135927f4d8c1a$export$ca000e230c0caa3e).answer < 1) (0, $5a8135927f4d8c1a$export$ca000e230c0caa3e).interpretation = "possible pre-renal azotemia";
    else (0, $5a8135927f4d8c1a$export$ca000e230c0caa3e).interpretation = "possible ATN";
};
const $9697ec0469b41fd7$export$c09ae31fe3548307 = function(values) {
    $9697ec0469b41fd7$var$determineCreatinine(values);
    $9697ec0469b41fd7$var$determineMagnesium(values);
    $9697ec0469b41fd7$var$calculateFe(values, 0.7);
};
const $9697ec0469b41fd7$export$5e389c9e64a86a56 = function(values) {
    $9697ec0469b41fd7$var$determineCreatinine(values);
    $9697ec0469b41fd7$var$calculateFe(values);
};
const $9697ec0469b41fd7$export$ab5f7de24f9136de = function(values) {
    $9697ec0469b41fd7$var$determineCreatinine(values);
    $9697ec0469b41fd7$var$calculateFe(values);
};
const $9697ec0469b41fd7$export$54687125a2efbb03 = function(values) {
    $9697ec0469b41fd7$var$determineCreatinine(values);
    $9697ec0469b41fd7$var$calculateFe(values);
};



var $461b5f79353dac97$exports = {};
$461b5f79353dac97$exports = new URL("nephcalc-high-resolution-logo-twitter.0636d1e8.png", import.meta.url).toString();


const $03cf872f16b5d10b$var$controlNav = function(title) {
    (0, $e4968b40bd2a919f$export$2e2bcd8739ae039).clear();
    if (!title) return;
    $5a8135927f4d8c1a$export$5e42ddf837e2ac74(title);
    (0, $193f87780df358da$export$2e2bcd8739ae039).toggleSideMenu();
    switch(title){
        case "FENa":
            (0, $e312b15f42b0bb41$export$2e2bcd8739ae039).render();
            (0, $e312b15f42b0bb41$export$2e2bcd8739ae039).addHandlerRender($03cf872f16b5d10b$var$controlFENa);
            break;
        case "FEMg":
            (0, $f19bc41f73be26c6$export$2e2bcd8739ae039).render();
            (0, $f19bc41f73be26c6$export$2e2bcd8739ae039).addHandlerRender($03cf872f16b5d10b$var$controlFEMg);
            break;
        case "FeUrea":
            (0, $1637ae1e99ea237d$export$2e2bcd8739ae039).render();
            (0, $1637ae1e99ea237d$export$2e2bcd8739ae039).addHandlerRender($03cf872f16b5d10b$var$controlFeUrea);
            break;
        case "OsmolarGap":
            (0, $5c396c13285f693e$export$2e2bcd8739ae039).render();
            (0, $5c396c13285f693e$export$2e2bcd8739ae039).addHandlerRender($03cf872f16b5d10b$var$controlOsmolarGap);
            $5a8135927f4d8c1a$export$5e42ddf837e2ac74("Osmolar Gap");
            break;
        case "EFreeWater":
            (0, $a312787cc7bfac19$export$2e2bcd8739ae039).render();
            (0, $a312787cc7bfac19$export$2e2bcd8739ae039).addHandlerRender($03cf872f16b5d10b$var$controlEFreeWaterClearance);
            $5a8135927f4d8c1a$export$5e42ddf837e2ac74("Free Water Clearance");
            break;
        case "FreeWaterDef":
            (0, $6131b0ab11ac723f$export$2e2bcd8739ae039).render();
            (0, $6131b0ab11ac723f$export$2e2bcd8739ae039).addHandlerRender($03cf872f16b5d10b$var$controlFreeWaterDef);
            (0, $6131b0ab11ac723f$export$2e2bcd8739ae039).addHandlerGender();
            $5a8135927f4d8c1a$export$5e42ddf837e2ac74("Free Water Deficit");
            break;
        case "UAG":
            (0, $a13a4baa8410dcf8$export$2e2bcd8739ae039).render();
            (0, $a13a4baa8410dcf8$export$2e2bcd8739ae039).addHandlerRender($03cf872f16b5d10b$var$controlUAG);
            $5a8135927f4d8c1a$export$5e42ddf837e2ac74("Urine Anion Gap");
            break;
        case "CrCl":
            (0, $05d89272644e736c$export$2e2bcd8739ae039).render();
            (0, $05d89272644e736c$export$2e2bcd8739ae039).addHandlerRender($03cf872f16b5d10b$var$controlCrCl);
            $5a8135927f4d8c1a$export$5e42ddf837e2ac74("CrCl");
            break;
        case "TTKG":
            (0, $920d0e85dce62342$export$2e2bcd8739ae039).render();
            (0, $920d0e85dce62342$export$2e2bcd8739ae039).addHandlerRender($03cf872f16b5d10b$var$controlTTKG);
            $5a8135927f4d8c1a$export$5e42ddf837e2ac74("TTKG");
            break;
        case "Winters":
            (0, $e216584d03032389$export$2e2bcd8739ae039).render();
            (0, $e216584d03032389$export$2e2bcd8739ae039).addHandlerRender($03cf872f16b5d10b$var$controlWinters);
            $5a8135927f4d8c1a$export$5e42ddf837e2ac74("Expected PCO2");
            break;
        case "SAG":
            (0, $b0a39dd7e68324c8$export$2e2bcd8739ae039).render();
            (0, $b0a39dd7e68324c8$export$2e2bcd8739ae039).addHandlerRender($03cf872f16b5d10b$var$controlSerumAnionGap);
            $5a8135927f4d8c1a$export$5e42ddf837e2ac74("Anion Gap");
            break;
        case "FECa":
            (0, $25f9f349bdffe75f$export$2e2bcd8739ae039).render();
            (0, $25f9f349bdffe75f$export$2e2bcd8739ae039).addHandlerRender($03cf872f16b5d10b$var$controlFECa);
            break;
        case "FEPO4":
            (0, $ed970a09156565a5$export$2e2bcd8739ae039).render();
            (0, $ed970a09156565a5$export$2e2bcd8739ae039).addHandlerRender($03cf872f16b5d10b$var$controlFEPO);
            break;
        case "CorrectedSodium":
            (0, $18793a966bd38522$export$2e2bcd8739ae039).render();
            (0, $18793a966bd38522$export$2e2bcd8739ae039).addHandlerRender($03cf872f16b5d10b$var$controlCorrectedSodium);
            $5a8135927f4d8c1a$export$5e42ddf837e2ac74("Corrected");
            break;
        case "UOG":
            (0, $0f4dc5caad29475f$export$2e2bcd8739ae039).render();
            (0, $0f4dc5caad29475f$export$2e2bcd8739ae039).addHandlerRender($03cf872f16b5d10b$var$controlUrineOsmolarGap);
            $5a8135927f4d8c1a$export$5e42ddf837e2ac74("Gap");
            break;
        case "CorrectedCalcium":
            (0, $f0c02b030a95713d$export$2e2bcd8739ae039).render();
            (0, $f0c02b030a95713d$export$2e2bcd8739ae039).addHandlerRender($03cf872f16b5d10b$var$controlCorrectedCalcium);
            $5a8135927f4d8c1a$export$5e42ddf837e2ac74("Corrected");
            break;
        case "TPV":
            (0, $f073d25bf91445dd$export$2e2bcd8739ae039).render();
            (0, $f073d25bf91445dd$export$2e2bcd8739ae039).addHandlerRender($03cf872f16b5d10b$var$controlTPV);
            $5a8135927f4d8c1a$export$5e42ddf837e2ac74("TPV");
            break;
        default:
            break;
    }
};
const $03cf872f16b5d10b$var$controlInterpretation = function() {
    (0, $8406b9e4d568f4c5$export$2e2bcd8739ae039).render($5a8135927f4d8c1a$export$ca000e230c0caa3e);
};
const $03cf872f16b5d10b$var$genControl = function(values, calculation) {
    try {
        if (values instanceof Error) throw Error(values);
        calculation(values);
        (0, $e4968b40bd2a919f$export$2e2bcd8739ae039).render($5a8135927f4d8c1a$export$ca000e230c0caa3e);
    } catch (err) {
        console.log(err);
        (0, $e4968b40bd2a919f$export$2e2bcd8739ae039).renderError();
    }
};
const $03cf872f16b5d10b$var$controlFENa = function(values) {
    $03cf872f16b5d10b$var$genControl(values, $9697ec0469b41fd7$export$5b84e5bc38d35d49);
};
const $03cf872f16b5d10b$var$controlFEMg = function(values) {
    $03cf872f16b5d10b$var$genControl(values, $9697ec0469b41fd7$export$c09ae31fe3548307);
};
const $03cf872f16b5d10b$var$controlFeUrea = function(values) {
    $03cf872f16b5d10b$var$genControl(values, $9697ec0469b41fd7$export$5e389c9e64a86a56);
};
const $03cf872f16b5d10b$var$controlOsmolarGap = function(values) {
    $03cf872f16b5d10b$var$genControl(values, $5a8135927f4d8c1a$export$507d97aea0e924af);
};
const $03cf872f16b5d10b$var$controlEFreeWaterClearance = function(values) {
    $03cf872f16b5d10b$var$genControl(values, $5a8135927f4d8c1a$export$2b4553184b655286);
};
const $03cf872f16b5d10b$var$controlFreeWaterDef = function(values) {
    $03cf872f16b5d10b$var$genControl(values, $5a8135927f4d8c1a$export$ad8ef1ae2dfea01a);
};
const $03cf872f16b5d10b$var$controlUAG = function(values) {
    $03cf872f16b5d10b$var$genControl(values, $5a8135927f4d8c1a$export$e21e2518db2872d2);
};
const $03cf872f16b5d10b$var$controlCrCl = function(values) {
    $03cf872f16b5d10b$var$genControl(values, $5a8135927f4d8c1a$export$a5c322cbbfb546bb);
};
const $03cf872f16b5d10b$var$controlTTKG = function(values) {
    $03cf872f16b5d10b$var$genControl(values, $5a8135927f4d8c1a$export$63ddbb1edc5cb637);
};
const $03cf872f16b5d10b$var$controlWinters = function(values) {
    $03cf872f16b5d10b$var$genControl(values, $5a8135927f4d8c1a$export$c13515ff9746e41);
};
const $03cf872f16b5d10b$var$controlSerumAnionGap = function(values) {
    $03cf872f16b5d10b$var$genControl(values, $5a8135927f4d8c1a$export$c45ea910e5730521);
};
const $03cf872f16b5d10b$var$controlFECa = function(values) {
    $03cf872f16b5d10b$var$genControl(values, $9697ec0469b41fd7$export$ab5f7de24f9136de);
};
const $03cf872f16b5d10b$var$controlFEPO = function(values) {
    $03cf872f16b5d10b$var$genControl(values, $9697ec0469b41fd7$export$54687125a2efbb03);
};
const $03cf872f16b5d10b$var$controlCorrectedSodium = function(values) {
    $03cf872f16b5d10b$var$genControl(values, $5a8135927f4d8c1a$export$2d0d9ab62031713e);
};
const $03cf872f16b5d10b$var$controlCorrectedCalcium = function(values) {
    $03cf872f16b5d10b$var$genControl(values, $5a8135927f4d8c1a$export$ea6ee1d9a056bd7a);
};
const $03cf872f16b5d10b$var$controlUrineOsmolarGap = function(values) {
    $03cf872f16b5d10b$var$genControl(values, $5a8135927f4d8c1a$export$4d6102d72c76245f);
};
const $03cf872f16b5d10b$var$controlTPV = function(values) {
    $03cf872f16b5d10b$var$genControl(values, $5a8135927f4d8c1a$export$f5d3318ee5a4f48a);
};
const $03cf872f16b5d10b$var$init = function() {
    (0, $193f87780df358da$export$2e2bcd8739ae039).addHandlerRender($03cf872f16b5d10b$var$controlNav);
    (0, $e4968b40bd2a919f$export$2e2bcd8739ae039).addHandlerRender($03cf872f16b5d10b$var$controlInterpretation);
};
$03cf872f16b5d10b$var$init();


//# sourceMappingURL=index.cf703ab7.js.map
